export default __webpack_public_path__ + "navigation-examples-basic-1200-5adf66531ed76acfbdba13ae83f0c912.webp";